import { render } from "./ManagerRow.vue?vue&type=template&id=bb3f94ec"
import script from "./ManagerRow.vue?vue&type=script&lang=js"
export * from "./ManagerRow.vue?vue&type=script&lang=js"

import "./ManagerRow.vue?vue&type=style&index=0&id=bb3f94ec&lang=css"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__